// extracted by mini-css-extract-plugin
module.exports = {"sidebarGroup":"SidebarGroup_sidebarGroup__1MrsX","title":"SidebarGroup_title__W1htx"};